import {
  avatar,
  background,
  captions,
  host,
  speaker,
  text,
  visualizer,
} from './helpers'
import type { TemplateBlueprint } from './types'

/**
 * `BlockLayout` (`layouts/BlockLayout.tsx`): a speaker strip on top,
 * captions, bars rising from under them, the episode block at the foot with
 * the host picture square against the edge. One line each for the title and
 * subtitle. The handle is centred on the avatar row, as v1's `items-center`
 * put it. Intended difference (#547): the subtitle ends at x 810 in portrait
 * and square, so a long one is cut clear of the watermark.
 */
const bars = { variant: 'equalizer' as const }
const episode = { weight: 700, lineHeight: 1.5 }

export const blockBlueprint: TemplateBlueprint = {
  kind: 'audio',
  orientations: {
    portrait: [
      background(),
      avatar('portrait', 50, 50, 70),
      {
        ...speaker('portrait', [150, 59, 700, 52], 'handle', {
          size: 40,
          weight: 700,
          lineHeight: 1.3,
        }),
        id: 'speaker',
      },
      captions('portrait', [90, 207, 900, 1063]),
      visualizer('portrait', [0, 1270, 1080, 380], bars),
      host('portrait', 0, 1650, 270, 'rect'),
      text('portrait', 'title', [320, 1725, 710, 60], { size: 40, ...episode }),
      text('portrait', 'subtitle', [320, 1785, 490, 60], {
        size: 40,
        ...episode,
      }),
    ],
    square: [
      background(),
      avatar('square', 50, 50, 70),
      {
        ...speaker('square', [150, 61, 700, 49], 'handle', {
          size: 38,
          weight: 700,
          lineHeight: 1.3,
        }),
        id: 'speaker',
      },
      captions('square', [70, 207, 940, 333]),
      visualizer('square', [0, 540, 1080, 300], bars),
      host('square', 0, 840, 240, 'rect'),
      text('square', 'title', [290, 906, 740, 54], {
        size: 38,
        weight: 700,
        lineHeight: 1.42,
      }),
      text('square', 'subtitle', [290, 960, 520, 54], {
        size: 38,
        weight: 700,
        lineHeight: 1.42,
      }),
    ],
    landscape: [
      background(),
      avatar('landscape', 50, 50, 70),
      {
        ...speaker('landscape', [150, 59, 700, 52], 'handle', {
          size: 40,
          weight: 700,
          lineHeight: 1.3,
        }),
        id: 'speaker',
      },
      captions('landscape', [90, 207, 1740, 373]),
      visualizer('landscape', [0, 580, 1920, 250], bars),
      host('landscape', 0, 830, 250, 'rect'),
      text('landscape', 'title', [320, 892, 1530, 63], {
        size: 42,
        ...episode,
      }),
      text('landscape', 'subtitle', [320, 955, 1530, 63], {
        size: 42,
        ...episode,
      }),
    ],
  },
}
